import styled, {css} from 'styled-components'
import backgroundImage from '@assets/images/quote_background.png'

export const StyledTitleWrapper = styled.div(
    ({theme: {spacing}}) => css`
        border-radius: 0 0 56px 56px;
        width: 100%;
        padding: ${spacing * 14}px;

        background-image: url(${backgroundImage});
        background-size: cover;
        background-position: right;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 8}px;
    `
)

export const StyledLogo = styled.div`
    ${() => css`
        display: flex;
        justify-content: center;

        & img {
            width: 210px;
        }
    `}
`

export const StyledBillingData = styled.div(
    ({theme: {palette, spacing}}) => css`
        border-top: 1px solid ${palette.neutral[50]};
        border-bottom: 1px solid ${palette.neutral[50]};
        padding: ${spacing * 7}px 0;

        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: flex-start;
    `
)

export const StyledDataTitle = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textLg};
    `
)

export const StyledQuoteName = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textMd};
        font-weight: 500;
    `
)

export const StyledContacts = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.primary[300]};
    `
)
